// HyperMD, copyright (c) by laobubu
// Distributed under an MIT license: http://laobubu.net/HyperMD/LICENSE
//
// DESCRIPTION: Fold and render emoji :smile:
//
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("codemirror"), require("../core"), require("./emoji/index"), require("./fold")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","codemirror","../core","./emoji/index","./fold"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.FoldEmoji = this.HyperMD.FoldEmoji || {}), CodeMirror, HyperMD, HyperMD.Emoji, HyperMD.Fold);
})(function (require, exports, CodeMirror, core_1, index_1, fold_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getAddon = exports.FoldEmoji = exports.suggestedOption = exports.defaultOption = exports.EmojiFolder = exports.defaultRenderer = exports.defaultChecker = void 0;
    CodeMirror = __importStar(CodeMirror);
    var defaultChecker = function (text) {
        return text in index_1.EmojiDefinitions || text in index_1.ReverseEmojiDefinitions;
    };
    exports.defaultChecker = defaultChecker;
    var defaultRenderer = function (text) {
        var el = document.createElement("span");
        el.textContent = index_1.EmojiDefinitions[text.replace(/^:(.+?):$/, "$1")] || text;
        el.title = text;
        return el;
    };
    exports.defaultRenderer = defaultRenderer;
    /********************************************************************************** */
    //#region Folder
    /**
     * Detect if a token is emoji and fold it
     *
     * @see FolderFunc in ./fold.ts
     */
    var EmojiFolder = function (stream, token) {
        if (!token.type || !/ formatting-emoji/.test(token.type))
            return null;
        var cm = stream.cm;
        var from = { line: stream.lineNo, ch: token.start };
        var to = { line: stream.lineNo, ch: token.end };
        var name = token.string; // with ":" or emoji
        var addon = exports.getAddon(cm);
        if (!addon.isEmoji(name.replace(/^:(.+?):$/, "$1")))
            return null;
        var reqAns = stream.requestRange(from, to);
        if (reqAns !== fold_1.RequestRangeResult.OK)
            return null;
        // now we are ready to fold and render!
        var marker = addon.foldEmoji(name, from, to);
        return marker;
    };
    exports.EmojiFolder = EmojiFolder;
    //#endregion
    fold_1.registerFolder("emoji", exports.EmojiFolder, true);
    exports.defaultOption = {
        myEmoji: {},
        emojiRenderer: exports.defaultRenderer,
        emojiChecker: exports.defaultChecker,
    };
    exports.suggestedOption = {};
    core_1.suggestedEditorConfig.hmdFoldEmoji = exports.suggestedOption;
    CodeMirror.defineOption("hmdFoldEmoji", exports.defaultOption, function (cm, newVal) {
        ///// convert newVal's type to `Partial<Options>`, if it is not.
        if (!newVal) {
            newVal = {};
        }
        ///// apply config and write new values into cm
        var inst = exports.getAddon(cm);
        for (var k in exports.defaultOption) {
            inst[k] = k in newVal ? newVal[k] : exports.defaultOption[k];
        }
    });
    //#endregion
    /********************************************************************************** */
    //#region Addon Class
    var FoldEmoji = /** @class */ (function () {
        function FoldEmoji(cm) {
            this.cm = cm;
            // options will be initialized to defaultOption when constructor is finished
        }
        FoldEmoji.prototype.isEmoji = function (text) {
            return text in this.myEmoji || this.emojiChecker(text);
        };
        FoldEmoji.prototype.foldEmoji = function (text, from, to) {
            var cm = this.cm;
            var el = (text in this.myEmoji && this.myEmoji[text](text)) ||
                this.emojiRenderer(text);
            if (!el || !el.tagName)
                return null;
            if (el.className.indexOf("hmd-emoji") === -1)
                el.className += " hmd-emoji";
            var marker = cm.markText(from, to, {
                replacedWith: el,
            });
            el.addEventListener("click", fold_1.breakMark.bind(this, cm, marker, 1), false);
            if (el.tagName.toLowerCase() === "img") {
                el.addEventListener("load", function () { return marker.changed(); }, false);
                el.addEventListener("dragstart", function (ev) { return ev.preventDefault(); }, false);
            }
            return marker;
        };
        return FoldEmoji;
    }());
    exports.FoldEmoji = FoldEmoji;
    //#endregion
    /** ADDON GETTER (Singleton Pattern): a editor can have only one FoldEmoji instance */
    exports.getAddon = core_1.Addon.Getter("FoldEmoji", FoldEmoji, exports.defaultOption /** if has options */);
});
/********************************************************************************** */
